module.exports = __webpack_public_path__ + "img/search_point.1d1791f.svg";